/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorRepresentation
 */
export interface ErrorRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ErrorRepresentation
     */
    message?: string;
}

/**
 * Check if a given object implements the ErrorRepresentation interface.
 */
export function instanceOfErrorRepresentation(value: object): value is ErrorRepresentation {
    return true;
}

export function ErrorRepresentationFromJSON(json: any): ErrorRepresentation {
    return ErrorRepresentationFromJSONTyped(json, false);
}

export function ErrorRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ErrorRepresentationToJSON(json: any): ErrorRepresentation {
    return ErrorRepresentationToJSONTyped(json, false);
}

export function ErrorRepresentationToJSONTyped(value?: ErrorRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

